import calendarCommitTypes from "./commit-types";


const INITIAL_CALENDAR_STATE = {
  myList: [],
  userList: []
};

function calendarReducers(state = INITIAL_CALENDAR_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case calendarCommitTypes.SET_MY_CALENDAR_EVENTS:
      return {
        ...state,
        myList: action.list,
      };
    case calendarCommitTypes.SET_CALENDAR_EVENTS:
      return {
        ...state,
        userList: action.list,
      };
    case calendarCommitTypes.CREATE_EVENT:
      return {
        ...state,
        myList: [...state.myList, action.event],
      };
    case calendarCommitTypes.UPDATE_EVENT:
      return {
        ...state,
        myList: state.myList.map(e => e.id === action.event.id ? action.event : e)
      };
    case calendarCommitTypes.DELETE_EVENT:
      return {
        ...state,
        myList: state.myList.filter(e => e.id !== action.event.id)
      };
    default:
      return state;
  }
}

export default calendarReducers
